import React,{useState} from 'react'
import Modal from '../../../components/Modal'

export default function PushNotificationModal({setModal,onClick}) {

  return (
    <Modal title="Push Notification" size="md">
        <div className="modal-inner-content">
            <p className="r-text m-weight f-op">Are you sure you want to push notification for this enquiry?</p>
        </div>
        <div className="modal-footer">
            <button className="xs-neutral-btn" onClick={()=>setModal(false)}>Cancel</button>
            <button className="xs-delete-btn" onClick={()=>onClick()}>Push Notification now</button>
        </div>
    </Modal>
  )
}
